/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Extract_Closed_LogInputs */

const en_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[DRASTIC close]: Closed caption extraction process closed`)
};

const fr_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[DRASTIC fermeture] : Processus d'extraction des sous-titres termine`)
};

const de_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[DRAMATISCHES Ende]: Der Prozess zur Extraktion der Untertitel wurde beendet.`)
};

const it_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Chiusura DRASTICA]: Processo di estrazione dei sottotitoli chiuso`)
};

const ru_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[КРАЙНЕЕ ЗАВЕРШЕНИЕ]: Процесс извлечения субтитров завершен`)
};

const es_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Cierre DRÁSTICO]: Proceso de extracción de subtítulos cerrado`)
};

const zh_cn2_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`【字幕提取流程已关闭】`)
};

const ja_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[DRASTIC 終了]: クローズドキャプション抽出プロセスが終了しました`)
};

const hi_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[अत्यावश्यक समाप्ति]: क्लोज्ड कैप्शन निकालने की प्रक्रिया बंद कर दी गई है।`)
};

const pt_pt2_drastic_tech_extract_closed_log = /** @type {(inputs: Drastic_Tech_Extract_Closed_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Fechamento drástico]: Processo de extração de legendas encerrado`)
};

/**
* | output |
* | --- |
* | "[DRASTIC close]: Closed caption extraction process closed" |
*
* @param {Drastic_Tech_Extract_Closed_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_closed_log = /** @type {((inputs?: Drastic_Tech_Extract_Closed_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Closed_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_extract_closed_log(inputs)
	if (locale === "de") return de_drastic_tech_extract_closed_log(inputs)
	if (locale === "it") return it_drastic_tech_extract_closed_log(inputs)
	if (locale === "ru") return ru_drastic_tech_extract_closed_log(inputs)
	if (locale === "es") return es_drastic_tech_extract_closed_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_extract_closed_log(inputs)
	if (locale === "ja") return ja_drastic_tech_extract_closed_log(inputs)
	if (locale === "hi") return hi_drastic_tech_extract_closed_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_extract_closed_log(inputs)
	return en_drastic_tech_extract_closed_log(inputs)
});